export default {
  email: {
    placeholder: 'Work email',
  },
  password: {
    placeholder: 'Strong password',
  },
};
